module.exports = __webpack_public_path__ + "img/top-function-search-id.88c44122.jpg";